import { Order } from './order';
import { CreativeMediaVariant } from './creative-media-variant';

export enum CreativeType {
    IMAGE = 'IMAGE', // Assets: GIF, JPG, PNG
    HTML5 = 'HTML5', // Assets: ZIP file
    VIDEO_VAST = 'VIDEO_VAST', // Video ads that appear during streaming content in video players or that display outside a video player.
    AUDIO_VAST = 'AUDIO_VAST', // Audio ads that play during audio content.
}

export interface Creative {
    id: number;
    name: string;
    type: CreativeType;
    size: string;
    url: string | null;
    orders: Order[];
    mimeType: string;
    mediaWidth: number | null;
    mediaHeight: number | null;
    bitrate: number | null;
    duration: number | null;
    companionAd: Creative;
    masterCreatives: Creative[] | null;
    mediaVariants: CreativeMediaVariant[];
    createdAt: Date;
    updatedAt: Date | null;
}

export type AddCreative = Omit<Creative, 'id' | 'createdAt' | 'updatedAt'>;
